import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import {useFulfillment} from './FulfillmentContent-hook'

export const FulfillmentContent = ({fulfillmentData}) => {
  const {fulfillmentJsonSchema, fulfillmentUISchema} = useFulfillment()
  const getVal = v => v || '-'
  return (
    <div>
      <JsonFormsWrapper
        jsonschema={fulfillmentJsonSchema}
        uischema={fulfillmentUISchema}
        data={{
          fulfilledQuantity: getVal(fulfillmentData?.fulfilledQuantity),
          trackingId: getVal(fulfillmentData?.trackingId),
          shippingDate: getVal(fulfillmentData?.shippingDate),
          rejectedQuantity: getVal(fulfillmentData?.rejectedQuantity),
        }}
      />
    </div>
  )
}
